import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Components } from '../../../_shared/interfaces';
import { ComponentsStoreService } from '../../../_shared/services';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, filter } from 'rxjs/operators';
import {ClrDropdownModule} from "@clr/angular";
import {NgForOf} from "@angular/common";
import {angleIcon, ClarityIcons} from "@cds/core/icon";

@Component({
  selector: 'app-component-search',
  standalone: true,
  imports: [
    ClrDropdownModule,
    NgForOf
  ],
  templateUrl: './component-search.component.html',
  styleUrl: './component-search.component.sass'
})
export class ComponentSearchComponent implements OnInit {
  isLoading = false;
  foundComponents: Components[] = [];

  // Search components
  keyUp$ = new Subject<string>();

  onKeyUp(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    this.keyUp$.next(inputElement.value);
  }

  @Input() componentID: string = '';
  @Input() technology: string = 'false';
  @Output() submitParentNumber = new EventEmitter();

  constructor(
    private compss: ComponentsStoreService
  ) {
    ClarityIcons.addIcons(angleIcon)
  }

  ngOnInit() {
    this.keyUp$.pipe(
      filter(term => term.length >= 3),
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      switchMap(searchTerm => this.compss.getAllSearch(searchTerm, this.technology, 'all', true)),
      tap(() => this.isLoading = false)
    )
      .subscribe(components => this.foundComponents = components.object);
  }

  addComponent(componentChild:string) {
    if (confirm('Wollen Sie die Teilkomponente ' + componentChild + ' zur Teileliste hinzufügen?')) {
      this.compss.addComponentsChild(componentChild, this.componentID, 1)
        .subscribe(data => {
          this.submitParentNumber.emit(true);
        });
    }
  }
}
